import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { GroupData } from "../types/GroupData";
import { useLoading } from "./useLoading";

export const useGroups = () => {
  const [groups, setGroups] = useState<GroupData[]>([]);

  const { isLoading, setIsLoading } = useLoading();

  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      const querySnapshot = await getDocs(collection(db, "groups"));

      const groupList: GroupData[] = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<GroupData, "id">),
      }));

      setGroups(groupList);
    } catch (error) {
      console.error("groups取得エラー:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return {
    groups,
    loading: isLoading,
    fetchGroups,
  };
};